const NON_BREAKING_SPACE = /(?:\u00a0|&nbsp;|&#160;|&#x0*a0;)/gi;

export const normalizePostWhitespace = (html: string): string =>
	html.replace(NON_BREAKING_SPACE, " ");
